// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point, Rectangle } from '@shared/commons/Geometry';
import { Cursors } from '@shared/commons/Cursors';
import { TerceraChartBaseRenderer } from './TerceraChartBaseRenderer';
import { Pen } from '@shared/commons/Graphics';
import { MouseButtons } from '@front/controls/UtilsClasses/ControlsUtils';
import { TerceraChartUtils } from '../TerceraChartUtils';
import { LayersEnum } from '../Utils/LayersEnum';
export class TerceraChartScalingByRectangleRenderer extends TerceraChartBaseRenderer {
    constructor(chart) {
        super(chart);
        this.Active = false;
        this.lastMouseDown = new Point();
        this.lastMouseMove = new Point();
        this.chart = chart;
        this.pen = new Pen('red', 1);
        this.assignLayer = LayersEnum.CrossHair;
        this.SetClassName('TerceraChartScalingByRectangleRenderer');
    }
    Draw(gr, window, windowsContainer, advParams = null) {
        if (this.Active && !this.lastMouseDown.IsEmpty()) {
            const rect = this.CurrentRect();
            gr.DrawRect(this.pen, rect.X, rect.Y, rect.Width, rect.Height);
        }
    }
    ProcessMouseDown(e) {
        var _a;
        if (e.Button != MouseButtons.Left) {
            return super.ProcessMouseDown(e);
        }
        this.lastMouseDown = e.Location;
        if (this.Active && ((_a = e.window) === null || _a === void 0 ? void 0 : _a.ClientRectangle.Contains(e.Location.X, e.Location.Y))) {
            return true;
        }
        else {
            return super.ProcessMouseDown(e);
        }
    }
    CurrentRect() {
        if (this.lastMouseDown.IsEmpty() || this.lastMouseMove.IsEmpty()) {
            return Rectangle.Empty();
        }
        return TerceraChartUtils.AbsRectangle(new Rectangle(this.lastMouseDown.X, this.lastMouseDown.Y, this.lastMouseMove.X - this.lastMouseDown.X, this.lastMouseMove.Y - this.lastMouseDown.Y));
    }
    ProcessMouseMove(e) {
        var _a;
        if (this.Active && ((_a = e.window) === null || _a === void 0 ? void 0 : _a.ClientRectangle.Contains(e.Location.X, e.Location.Y))) {
            this.lastMouseMove = e.Location;
            e.NeedRedraw |= LayersEnum.CrossHair;
            return true;
        }
        else {
            if (this.lastMouseDown.IsEmpty()) {
                this.lastMouseMove = Point.Empty();
            }
            return super.ProcessMouseMove(e);
        }
    }
    ProcessMouseUp(e) {
        var _a;
        const scalingRect = this.CurrentRect();
        const startPoint = this.lastMouseDown;
        this.lastMouseDown = Point.Empty();
        this.lastMouseMove = Point.Empty();
        if (this.Active && ((_a = e.window) === null || _a === void 0 ? void 0 : _a.ClientRectangle.Contains(e.Location.X, e.Location.Y))) {
            if (!scalingRect.IsEmpty() && scalingRect.Width > 1 && scalingRect.Height > 1) {
                this.chart.ZoomToRectangle(scalingRect, startPoint);
            }
            return true;
        }
        else {
            return super.ProcessMouseUp(e);
        }
    }
    ProcessMouseLeave(e) {
        super.ProcessMouseLeave(e);
        this.lastMouseDown = Point.Empty();
        this.lastMouseMove = Point.Empty();
    }
    GetCursor(e) {
        var _a;
        if (this.Active && ((_a = e.window) === null || _a === void 0 ? void 0 : _a.ClientRectangle.Contains(e.Location.X, e.Location.Y))) {
            for (let i = 0, len = this.chart.windowsContainer.Windows.length; i < len; i++) {
                if (this.chart.windowsContainer.Windows[i].ClientRectangle.Contains(e.Location.X, e.Location.Y)) {
                    return Cursors.Cross;
                }
            }
        }
        return null;
    }
}
